import React from "react"
import PropTypes from "prop-types"

import H3 from "../atoms/H3"
import Grid from "../organisms/Grid"
import styles from "./CopyBlock.module.css"

const CopyBlock = props => (
  <Grid type="tight rows">
    <div className={styles.icon}>{props.icon}</div>
    <H3>{props.title}</H3>
    <div>{props.children}</div>
  </Grid>
)

CopyBlock.propTypes = {
  icon: PropTypes.element.isRequired,
  title: PropTypes.string.isRequired,
}

export default CopyBlock
